document.addEventListener("DOMContentLoaded", function () {
  let submitButton = document.querySelector(
    ".product-form__buttons .product-form__submit"
  );

  const a = document.getElementById("year"),
    e = document.getElementById("make"),
    r = document.getElementById("model"),
    i = document.getElementById("compatibility-message"),
    o = {
      1999: ["Honda", "Toyota"],
      2e3: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Mazda",
        "Mercedes",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2001: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Mazda",
        "Mercedes",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2002: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2003: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2004: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2005: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2006: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2007: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2008: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2009: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2010: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Pontiac",
        "Saab",
        "Saturn",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2011: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Saab",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2012: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2013: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2014: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2015: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Scion",
        "Subaru",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2016: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Scion",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2017: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2018: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2019: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2020: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2021: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2022: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2023: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mini",
        "Mitsubishi",
        "Nissan",
        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2024: [
        "Acura",
        "Audi",
        "BMW",
        "Buick",
        "Cadillac",
        "Chevrolet",
        "Chrysler",
        "Dodge",
        "Ford",
        "GMC",
        "Genesis",
        "Honda",
        "Hyundai",
        "Infiniti",
        "Jaguar",
        "Jeep",
        "Kia",
        "Land Rover",
        "Lexus",
        "Lexus (No Entertainment System)",
        "Lincoln",
        "Maserati",
        "Mazda",
        "Mercedes",
        "Mercedes-Benz",
        "Mini",
        "Mitsubishi",
        "Nissan",

        "Subaru",
        "Tesla",
        "Toyota",
        "Volkswagen",
        "Volvo",
      ],
      2025: ["Dodge", "Ram", "Toyota"],
    },
    n = {
      2025: {
        Dodge: ["Ram 1500", "Ram 2500", "Ram 3500"],
        Ram: ["1500", "2500", "3500"],
        Toyota: ["Camry"],
      },
      2024: {
        Acura: ["Integra", "MDX", "RDX", "TLX"],
        Audi: [
          "A3",
          "A4",
          "A5",
          "A6",
          "A7",
          "A8",
          "E-Tron GT",
          "Q3",
          "Q4 E-Tron",
          "Q5",
          "Q7",
          "Q8",
          "Q8 E-Tron",
          "RS E-Tron GT",
          "RS Q8",
          "RS3",
          "RS5",
          "RS6",
          "RS7",
          "S3",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "SQ7",
          "SQ8",
          "SQ8 E-Tron",
        ],
        BMW: [
          "2 Series Coupe",
          "3 Series",
          "330i sedan",
          "430i xDrive Coupe",
          "5 Series",
          "7 Series",
          "8 Series",
          "M2",
          "M3",
          "M4",
          "M440i xDrive Coupe",
          "M8",
          "X1 28i",
          "X3 30i",
          "X3 M",
          "X3 M40i",
          "X4",
          "X4 M",
          "X4 M40i",
          "X5 M",
          "X5 M40i",
          "X5 M60i",
          "X6 M",
          "X6 M40i",
          "X6 M60i",
          "X7 40i",
          "X7 60i",
          "X7 Alpina XB7",
          "XM",
          "Z4 30i",
          "Z4 40i",
          "i4",
          "i4 M50",
          "i4 eDrive35",
          "i5",
          "i7",
          "iX",
        ],
        Buick: [
          "Enclave",
          "Encore GX",
          "Encore GX Avenir",
          "Envista",
          "Evista",
        ],

        Cadillac: [
          "CT4",
          "CT5",
          "CT5-V",
          "Escalade",
          "LYRIQ",
          "XT4",
          "XT5",
          "XT6",
        ],
        Chevrolet: [
          "Blazer",
          "Blazer EV",
          "Camaro",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Malibu",
          "Silverado 1500",
          "Silverado 1500 Crew Cab",
          "Silverado 1500 Double Cab",
          "Silverado 1500 Regular Cab/Long Bed",
          "Silverado 2500 Double Cab/Crew Cab",
          "Silverado 2500 HD",
          "Silverado 2500 HD Double Cab/Crew cab",
          "Silverado 3500 HD",
          "Silverado 3500HD Chasis",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Trax",
        ],
        Chrysler: ["Pacifica"],
        Dodge: [
          "Durango",
          "Hornet",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
        ],
        Ford: [
          "Bronco Raptor",
          "Bronco Sport",
          "E-Series Chassis",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "F-550 Chassis",
          "Maverick",
          "Mustang",
          "Ranger",
          "Transit",
        ],
        GMC: [
          "Canyon",
          "Hummer EV",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Sierra 3500HD Chassis",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G80 3.5T", "G90", "GV60", "GV70", "GV80"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic Hatchback",
          "Civic SI",
          "Civic Type R",
          "HR-V",
          "Odyssey",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Elantra",
          "Elantra N Line",
          "Ioniq 5",
          "Ioniq 6",
          "Kona",
          "Kona N Line",
          "Palisade",
          "Santa Cruz",
          "Sonata",
          "Tucson",
          "Venue",
        ],
        Infiniti: ["QX50", "QX55", "QX60"],
        Jaguar: ["E-PACE", "F-TYPE", "I-PACE", "XF"],
        Jeep: [
          "Compass",
          "Grand Cherokee",
          "Grand Cherokee L",
          "Grand Wagoneer",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Carnival LX, SX",
          "EV6",
          "Forte",
          "K5",
          "Niro",
          "Seltos",
          "Sorento",
          "Soul",
          "Telluride",
        ],
        "Land Rover": ["Defender", "Discovery", "Range Rover"],
        Lexus: ["ES", "IS", "LC", "NX", "RC", "RC, F", "RX", "RX Hybrid"],
        "Lexus (No Entertainment System)": ["LX"],
        Lincoln: ["Corsair", "Nautilus", "Navigator"],
        Maserati: [
          "Ghibli",
          "GranTurismo",
          "Grecale",
          "Levante",
          "Quattroporte",
        ],
        Mazda: ["CX-30", "CX-5", "CX-50", "CX-90", "MAZDA3"],
        Mercedes: [
          "C-Class C300",
          "CLA-Class 250",
          "E-Class (All Except Convertible)",
          "EQE 350+",
          "EQE SUV",
          "G-Class G",
          "GLA-Class",
          "GLB-Class",
          "GLC-Class",
          "GLS-Class",
          "S-Class 580",
          "Sprinter",
        ],
        "Mercedes-Benz": ["GLE-Class"],
        Mini: ["Cooper", "Cooper Clubman", "Countryman Classic Cooper"],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Ariya",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Z",
        ],
        Ram: ["1500", "2500", "3500", "3500 Chassis", "ProMaster"],
        Subaru: [
          "Ascent",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Camry",
          "Corolla",
          "Corolla Cross",
          "Corolla Hatchback",
          "Corolla Hybrid",
          "Crown",
          "GR",
          "Grand Highlander",
          "Highlander",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Capstone",
          "Sequoia Platinum",
          "Sequoia TRD",
          "Sienna",
          "Tacoma (SR,SR5,TRD)",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Atlas",
          "Atlas Sport",
          "Golf GTI",
          "Golf R Coupe",
          "Jetta",
          "Jetta GLI",
          "Taos",
          "Tiguan",
        ],
        Volvo: ["C40 Recharge", "S60", "V60", "V90", "XC40", "XC60", "XC90"],
      },
      2023: {
        Acura: ["ILX", "Integra", "MDX", "NSX", "RDX", "TLX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A5 Sportback",
          "A6",
          "A6 Allroad",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "E-Tron",
          "E-Tron GT",
          "E-Tron S",
          "Q3",
          "Q4",
          "Q5",
          "Q7",
          "Q8",
          "RS E-Tron",
          "RS E-Tron GT",
          "RS Q8",
          "RS3",
          "RS5",
          "RS6",
          "RS7",
          "S3",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "SQ8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "300e Hybrid",
          "330e",
          "330i Sedan",
          "430i xDrive Coupe",
          "530e",
          "540i Sedan",
          "740i",
          "745e xDrive",
          "750Li",
          "750i",
          "840i",
          "Alpina B7",
          "Alpina B8",
          "IX",
          "M2",
          "M340i Sedan",
          "M440i xDrive Coupe",
          "M550i",
          "M760i xDrive",
          "M8",
          "M850i",
          "X1 28i",
          "X2 28i",
          "X3 30i",
          "X3 M35i",
          "X3 M40i",
          "X4",
          "X4 M",
          "X5",
          "X5 40i",
          "X6",
          "X7",
          "i4 M50",
          "i4 eDrive35",
          "i4 eDrive40",
        ],
        Buick: ["Enclave", "Encore", "Envision"],
        Chrysler: ["300"],
        Cadillac: [
          "CT4",
          "CT4-V",
          "CT5",
          "CT5-V",
          "Escalade",
          "LYRIQ",
          "XT4",
          "XT5",
          "XT6",
        ],
        Chevrolet: [
          "Blazer",
          "Bolt",
          "Camaro",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Suburban",
          "Tahoe",
          "Trailblazer",
          "Traverse",
        ],
        Chrysler: ["300"],
        Dodge: [
          "Challenger",
          "Charger",
          "Durango",
          "Hornet",
          "ProMaster",
          "ProMaster Chassis",
          "Ram 1500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Bronco 2-Door",
          "Bronco 4-Door",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Maverick",
          "Mustang",
          "Ranger",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Hummer EV",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G70", "G80", "G90", "GV60", "GV70", "GV80"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "HR-V",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Elantra",
          "Ioniq",
          "Kona",
          "Nexo",
          "Palisade",
          "Santa Cruz",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Venue",
        ],
        Infiniti: ["QX50", "QX55", "QX60"],
        Jaguar: ["F-PACE", "F-type", "I-PACE", "XF"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Gladiator",
          "Grand Cherokee",
          "Grand Wagoneer",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Carnival EX, SX Prestige",
          "Carnival LX, SX",
          "EV6",
          "Forte",
          "K5",
          "Niro",
          "Rio",
          "Seltos",
          "Sorento",
          "Soul",
          "Sportage",
          "Stinger",
          "Telluride",
        ],
        "Land Rover": [
          "Defender",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GX",
          "IS",
          "IS Convertible",
          "LC",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
          "RZ",
          "UX",
        ],
        Lincoln: ["Aviator", "Nautilus", "Navigator"],
        Maserati: ["Ghibli", "Grecale", "Levante", "MC20", "Quattroporte"],
        Mazda: ["CX-30", "CX-5", "CX-50", "CX-9", "MAZDA3", "MX-30", "Miata"],
        Mercedes: [
          "AMG GT53",
          "AMG GT63",
          "E-Class (All Except Convertible)",
          "EQS",
          "GLA Class",
          "GLB Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 550",
          "S-Class 580",
          "SL Class",
        ],
        Mini: [
          "Cooper",
          "Cooper Clubman",
          "Cooper Countryman",
          "Cooper Countryman Hybrid",
        ],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "400Z",
          "Altima Sedan",
          "Ariya",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        Subaru: [
          "Ascent",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "BZ4X",
          "Camry",
          "Corolla",
          "Corolla Cross",
          "Crown",
          "GR86",
          "Highlander",
          "Mirai",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Capstone",
          "Sequoia Platinum",
          "Sequoia TRD",
          "Sienna",
          "Supra",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Atlas",
          "Atlas Cross Sport",
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Passat",
          "Tiguan",
          "ID.4",
        ],
        Volvo: [
          "C40 Recharge",
          "S60",
          "S90",
          "V60",
          "V90",
          "XC40",
          "XC60",
          "XC90",
        ],
      },
      2022: {
        Acura: ["ILX", "MDX", "NSX", "RDX", "TLX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A5 Sportback",
          "A6",
          "A6 Allroad",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "E-Tron",
          "E-Tron GT",
          "E-Tron S",
          "Q3",
          "Q4",
          "Q5",
          "Q7",
          "Q8",
          "RS E-Tron",
          "RS E-Tron GT",
          "RS Q8",
          "RS3",
          "RS5",
          "RS6",
          "RS7",
          "S3",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "SQ8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "2 Series Convertible/Coupe",
          "300e Hybrid",
          "330e",
          "330i Sedan",
          "430i xDrive Coupe",
          "530e",
          "530i",
          "540i Sedan",
          "740i",
          "745e xDrive",
          "750Li",
          "750i",
          "840i",
          "Alpina B7",
          "Alpina B8",
          "IX",
          "M2",
          "M340i Sedan",
          "M440i xDrive Coupe",
          "M550i",
          "M760i xDrive",
          "M8",
          "M850i",
          "X1 28i",
          "X2 28i",
          "X2 M35i",
          "X2 xDrive28i",
          "X3 30i",
          "X3 M35i",
          "X3 M40i",
          "X4",
          "X4 M",
          "X5",
          "X5 40i",
          "X6",
          "X7",
          "i4 M50",
          "i4 eDrive40",
        ],
        Buick: ["Enclave", "Encore", "Envision"],
        Chrysler: ["300"],
        Cadillac: [
          "CT4",
          "CT4-V",
          "CT5",
          "CT5-V",
          "Escalade",
          "XT4",
          "XT5",
          "XT6",
        ],
        Chevrolet: [
          "Blazer",
          "Bolt",
          "Camaro",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Silverado 6500 HD Chassis",
          "Spark",
          "Suburban",
          "Tahoe",
          "Trailblazer",
          "Traverse",
          "Trax",
        ],
        Chrysler: ["300"],
        Dodge: [
          "Challenger",
          "Charger",
          "Durango",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Bronco 2-Door",
          "Bronco 4-Door",
          "E Series",
          "EcoSport",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Maverick",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Hummer EV",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G70", "G80", "G90", "GV70", "GV80"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "HR-V",
          "Insight",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Ioniq",
          "Kona",
          "Nexo",
          "Palisade",
          "Santa Cruz",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster N",
          "Venue",
        ],
        Infiniti: ["Q60", "QX50", "QX55", "QX60", "QX80"],
        Jaguar: ["E-PACE", "F-PACE", "F-type", "I-PACE", "XF"],
        Kia: [
          "Carnival EX, SX Prestige",
          "Carnival LX, SX",
          "EV6",
          "Forte",
          "K5",
          "Niro",
          "Rio",
          "Seltos",
          "Sorento",
          "Soul",
          "Sportage",
          "Stinger",
          "Telluride",
        ],
        "Land Rover": [
          "Defender",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SE",
          "Range Rover Evoque SVR",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GX",
          "IS",
          "IS Convertible",
          "LC",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
          "UX",
        ],
        Lincoln: ["Aviator", "Corsair", "Nautilus", "Navigator"],
        Maserti: ["Ghibli", "Levante", "MC20", "Quattroporte"],
        Mazda: ["CX-30", "CX-5", "CX-9", "MAZDA3", "MX-30", "Miata"],
        "Mercedes-Benz": [
          "A-Class",
          "AMG GT53",
          "AMG GT63",
          "C-Class AMG",
          "CLA Class 250",
          "CLA Class AMG",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "EQS",
          "G Class",
          "GLA Class",
          "GLB Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 550",
          "S-Class 580",
          "SL Class",
          "Sprinter",
        ],
        Mini: [
          "Cooper",
          "Cooper Clubman",
          "Cooper Countryman",
          "Cooper Countryman Hybrid",
        ],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        RAM: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "5500 Chassis",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Subaru: [
          "Ascent",
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Avalon",
          "C-HR",
          "Camry",
          "Corolla",
          "Corolla Cross",
          "GR86",
          "Highlander",
          "Mirai",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Nightshade",
          "Sequoia Platinum",
          "Sequoia TRD",
          "Sienna",
          "Supra",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Arteon",
          "Atlas",
          "Atlas Cross Sport",
          "Golf",
          "ID.4",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Taos",
          "Tiguan",
        ],
        Volvo: [
          "C40 Recharge",
          "S60",
          "S90",
          "V60",
          "V90",
          "XC40",
          "XC60",
          "XC90",
        ],
      },
      2021: {
        Acura: ["ILX", "MDX", "NSX", "RDX", "TLX"],
        Chrysler: ["300"],
        Audi: [
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A5 Sportback",
          "A6",
          "A6 Allroad",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "E-Tron",
          "Q3",
          "Q5",
          "Q7",
          "Q8",
          "RS Q8",
          "RS3",
          "RS5",
          "RS6",
          "RS7",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "SQ8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "120 Ah",
          "2 Series Convertible/Coupe",
          "2 Series Gran Coupe",
          "300e Hybrid",
          "330e",
          "330i Sedan",
          "430i xDrive Coupe",
          "530e",
          "530i",
          "540i Sedan",
          "740i",
          "745e xDrive",
          "750Li",
          "750i",
          "840i",
          "Alpina B7",
          "M2",
          "M340i Sedan",
          "M440i xDrive Coupe",
          "M550i",
          "M760i xDrive",
          "M8",
          "M850i",
          "X1 28i",
          "X2 28i",
          "X2 M35i",
          "X2 xDrive28i",
          "X3 30i",
          "X3 M35i",
          "X3 M40i",
          "X4",
          "X4 M",
          "X5",
          "X5 40i",
          "X6",
          "X7",
        ],
        Buick: ["Enclave", "Encore", "Envision"],
        Cadillac: ["CT4", "CT5", "Escalade", "XT4", "XT5", "XT6"],
        Chevrolet: [
          "Blazer",
          "Bolt",
          "Camaro",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Spark",
          "Suburban",
          "Tahoe",
          "Trailblazer",
          "Traverse",
          "Trax",
        ],
        Chrysler: ["300"],
        Dodge: [
          "Challenger",
          "Charger",
          "Durango",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Bronco 2-Door",
          "Bronco 4-Door",
          "E Series",
          "EcoSport",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G70", "G80", "G90", "GV80"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "Clarity Hybrid",
          "HR-V",
          "Insight",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Ioniq",
          "Kona",
          "Nexo",
          "Palisade",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster GL, Premium, SE, Turbo",
          "Veloster N",
          "Venue",
        ],
        Infiniti: ["Q50", "Q60", "QX50", "QX80"],
        Jaguar: ["E-PACE", "F-PACE", "F-type", "I-PACE", "XF"],
        Kia: [
          "Carnival EX, SX Prestige",
          "Carnival LX, SX",
          "EV6",
          "Forte",
          "K5",
          "Niro",
          "Rio",
          "Seltos",
          "Sorento",
          "Soul",
          "Sportage",
          "Stinger",
          "Telluride",
        ],
        "Land Rover": [
          "Defender",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SE",
          "Range Rover Evoque SVR",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GX",
          "IS",
          "IS Convertible",
          "LC",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
          "UX",
        ],
        Lincoln: ["Aviator", "Corsair", "Nautilus", "Navigator"],
        Maserati: ["Ghibli", "Levante", "MC20", "Quattroporte"],
        Mazda: ["CX-30", "CX-5", "CX-9", "MAZDA3", "MX-30", "Miata"],
        "Mercedes-Benz": [
          "A-Class",
          "AMG GT53",
          "AMG GT63",
          "C-Class AMG",
          "CLA Class 250",
          "CLA Class AMG",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "EQS",
          "G Class",
          "GLA Class",
          "GLB Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 550",
          "S-Class 580",
          "SL Class",
          "Sprinter",
        ],
        Mini: [
          "Cooper",
          "Cooper Clubman",
          "Cooper Countryman",
          "Cooper Countryman Hybrid",
        ],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        RAM: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "5500 Chassis",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Subaru: [
          "Ascent",
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Avalon",
          "C-HR",
          "Camry",
          "Corolla",
          "Corolla Cross",
          "GR86",
          "Highlander",
          "Mirai",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Nightshade",
          "Sequoia Platinum",
          "Sequoia TRD",
          "Sienna",
          "Supra",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Arteon",
          "Atlas",
          "Atlas Cross Sport",
          "Golf",
          "ID.4",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Taos",
          "Tiguan",
        ],
        Volvo: [
          "C40 Recharge",
          "S60",
          "S90",
          "V60",
          "V90",
          "XC40",
          "XC60",
          "XC90",
        ],
      },
      1999: {
        Honda: ["Accord"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Highlander",
          "RAV4",
          "Solara Convertible",
          "Tacoma",
          "Tundra",
        ],
      },
      2001: {
        Chrysler: [
          "PT Cruiser",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "S8",
          "TT",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "540i Wagon",
          "740iL",
          "750iL",
          "Ci Convertible/Coupe",
          "X5",
        ],
        Buick: ["LeSabre", "Regal"],
        Cadillac: ["Deville", "Eldorado", "Escalade"],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
        ],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
        ],
        GMC: ["Envoy", "Sierra 1500", "Sierra 2500HD"],
        Honda: ["Accord", "Insight", "S2000"],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG300",
        ],
        Jaguar: ["XJ", "XK"],
        Jeep: ["Grand Cherokee"],
        Kia: ["Optima", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: ["ES", "GS", "IS", "IS Convertible", "LS", "LX", "RX", "SC"],
        Lincoln: ["Navigator"],
        Mazda: ["Miata", "Tribute"],
        Mercedes: [
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
        ],
        Mitsubishi: ["Eclipse", "Galant", "Lancer"],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5"],
        Subaru: ["Forester", "Impreza", "Impreza RS", "Legacy", "Outback"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
        ],
        Volkswagen: ["Beetle", "Golf", "Golf GTI", "Jetta", "Passat"],
        Volvo: ["C70", "S40", "S60", "S80"],
      },
      2002: {
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "TT",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330i Sedan",
          "330xi Sedan",
          "525i",
          "540i Wagon",
          "745Li",
          "745i",
          "Ci Convertible/Coupe",
          "X5",
        ],
        Buick: ["LeSabre", "Regal"],
        Cadillac: ["Deville", "Eldorado", "Escalade"],
        Chevrolet: [
          "Avalanche",
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Chrysler: [
          "PT Crusier",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "Taurus",
          "Thunderbird",
        ],
        GMC: ["Envoy", "Sierra 1500", "Sierra 2500 HD", "Sierra 2500HD"],
        Honda: ["Accord", "Civic", "Insight", "S2000"],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG350",
        ],
        Jaguar: ["XJ", "XK"],
        Jeep: ["Grand Cherokee", "Liberty"],
        Kia: ["Optima", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: ["ES", "GS", "IS", "IS Convertible", "LS", "LX", "RX", "SC"],
        Lincoln: ["Navigator"],
        Mazda: ["Miata", "Tribute"],
        Mercedes: [
          "C-Class C230",
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "SLK Class",
        ],
        Mini: ["Cooper"],
        Mitsubishi: ["Eclipse", "Galant", "Lancer", "Outlander"],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5"],
        Saturn: ["VUE"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX Base, TR",
          "WRX Wagon, Hatchback",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
        ],
        Volvo: ["C70", "S40", "S60", "S80"],
      },
      2003: {
        Chrysler: [
          "PT Cruiser",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Acura: ["CL", "MDX", "NSX", "RSX", "TL"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "TT",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "525i",
          "525xi",
          "540i Wagon",
          "745Li",
          "745i",
          "760Li",
          "X5",
        ],
        Buick: ["LeSabre", "Regal"],
        Cadillac: ["CTS Sedan", "Deville", "Escalade"],
        Chevrolet: [
          "Avalanche",
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "SSR",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
          "Thunderbird",
        ],
        GMC: ["Envoy", "Sierra 1500", "Sierra 2500 HD", "Sierra 2500HD"],
        Honda: ["Accord", "Civic", "Element", "Insight", "Pilot", "S2000"],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG350",
        ],
        Infiniti: ["FX35", "G35", "G35 Coupe"],
        Jaguar: ["XJ", "XK"],
        Jeep: [
          "Grand Cherokee",
          "Liberty",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Sorento", "Spectra"],
        "Land Rover": ["Range Rover"],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["Aviator", "Navigator"],
        Mazda: ["MAZDA6", "Miata", "Tribute"],
        Mercedes: [
          "C-Class C230",
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "SLK Class",
        ],
        Mini: ["Cooper"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Sentra",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix", "Vibe"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5"],
        Saturn: ["ION", "VUE"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX Base, TR",
          "WRX Wagon, Hatchback",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2004: {
        Chrysler: [
          "Crossfire",
          "PT Cruiser",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RSX", "TSX"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "S8",
          "TT",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "540i Wagon",
          "740iL",
          "750iL",
          "Ci Convertible/Coupe",
          "X5",
          "525i",
          "525xi",
          "545i",
          "745Li",
          "745i",
          "760Li",
          "X3",
        ],
        Buick: ["LeSabre", "Regal"],
        Cadillac: ["Deville", "Eldorado", "Escalade", "CTS Sedan", "SRX"],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Avalanche",
          "Aveo",
          "SSR",
          "Trailblazer",
        ],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
          "Thunderbird",
        ],
        GMC: ["Envoy", "Sierra 1500", "Sierra 2500HD", "Canyon"],
        Honda: ["Accord", "Civic", "Element", "Insight", "Pilot", "S2000"],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG350",
        ],
        Infiniti: ["FX35", "G35", "G35 Coupe"],
        Jaguar: ["XJ", "XK"],
        Jeep: [
          "Grand Cherokee",
          "Liberty",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Sorento", "Spectra"],
        "Land Rover": ["Range Rover"],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["Navigator", "Aviator"],
        Mazda: ["MAZDA3", "MAZDA6", "Miata", "Tribute"],
        Mercedes: [
          "C-Class C230",
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "SLK Class",
        ],
        Mini: ["Cooper"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Titan",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix", "GTO", "Vibe"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5"],
        Saturn: ["ION", "VUE"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Passat",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2006: {
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "RSX", "TL", "TSX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "TT",
        ],
        BMW: [
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325xi Sedan",
          "325xi Wagon",
          "328i Convertible/Coupe",
          "328i Sedan",
          "328xi Coupe",
          "328xi Wagon",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330i Sedan",
          "330xi Sedan",
          "525i",
          "525xi",
          "530xi",
          "750Li",
          "750i",
          "760Li",
          "X5",
        ],
        Buick: ["La Crosse", "Lucerne"],
        Cadillac: ["CTS Sedan", "DTS", "Escalade", "SRX", "STS"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Caprice",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "SSR",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Chrysler: [
          "300",
          "Crossfire",
          "PT Cruiser Convertible",
          "PT Crusier",
          "PT Crusier Convertible",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Dodge: [
          "Charger",
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Taurus",
        ],
        GMC: [
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500 HD",
          "Sierra 2500HD",
        ],
        Honda: [
          "Accord",
          "Civic",
          "Element",
          "Insight",
          "Pilot",
          "Ridgeline",
          "S2000",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "Tucson",
        ],
        Infiniti: ["FX35", "G35", "G35 Coupe", "M35"],
        Jaguar: ["XJ", "XK"],
        Jeep: ["Commander", "Liberty", "Wrangler 2-Door", "Wrangler 4-Door"],
        Kia: ["Optima", "Rio", "Sorento", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["Navigator"],
        Mazda: ["MAZDA3", "MAZDA6", "Miata", "Tribute"],
        Mercedes: [
          "C-Class C230",
          "CL-Class",
          "CLK Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper"],
        Nissan: [
          "350Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Titan",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5", "9-2x", "9-3 SportCombi", "9-7x"],
        Saturn: ["ION", "VUE"],
        Scion: ["tC"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Maserati: ["Quattroporte"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza Special Edition",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2007: {
        Maserati: ["Quattroporte"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q7",
          "S4 Cabriolet",
          "S4 Sedan",
          "S6",
          "S8",
        ],
        BMW: [
          "1 Series",
          "328i Convertible/Coupe",
          "328i Sedan",
          "328i Wagon",
          "328xi Coupe",
          "328xi Sedan",
          "328xi Wagon",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335xi Coupe",
          "335xi Sedan",
          "525i",
          "525xi",
          "530xi",
          "750Li",
          "750i",
          "760Li",
          "Alpina B7",
          "X5",
        ],
        Buick: ["La Crosse", "Lucerne"],
        Cadillac: ["CTS Sedan", "DTS", "Escalade", "SRX", "STS"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Chrysler: [
          "300",
          "Crossfire",
          "PT Cruiser Convertible",
          "PT Crusier",
          "PT Crusier Convertible",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Dodge: [
          "Caliber",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "Civic",
          "Element",
          "Fit",
          "Pilot",
          "Ridgeline",
          "S2000",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "Tucson",
          "Vera Cruz",
        ],
        Infiniti: ["FX35", "G35 Coupe", "G35 Sedan", "M35"],
        Jaguar: ["XJ", "XK"],
        Jeep: [
          "Commander",
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Rio", "Sorento", "Spectra", "Sportage"],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Sport",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["MKX", "MKZ", "Navigator"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class C230",
          "CL-Class",
          "CLK Class",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "GL Class",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["G6", "Grand Prix", "Solstice", "Vibe"],
        Ram: ["1500", "2500", "3500", "3500 Chassis", "Dakota"],
        Saab: ["9 3", "9 5", "9-3 SportCombi", "9-7x"],
        Saturn: ["Aura", "ION", "Sky", "VUE"],
        Scion: ["tC"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza Special Edition",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2005: {
        Chrysler: [
          "300",
          "Crossfire",
          "PT Cruiser Convertible",
          "PT Crusier",
          "PT Crusier Convertible",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Maserati: ["Quattroporte"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "RSX", "TL", "TSX"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "S8",
          "TT",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "540i Wagon",
          "745Li",
          "745i",
          "760Li",
          "X3",
          "X5",
        ],
        Buick: ["La Crosse", "LeSabre", "Regal"],
        Cadillac: [
          "CTS Sedan",
          "Deville",
          "Eldorado",
          "Escalade",
          "SRX",
          "STS",
        ],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "SSR",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
          "Thunderbird",
        ],
        GMC: ["Canyon", "Envoy", "Sierra 1500", "Sierra 2500 HD"],
        Honda: ["Accord", "Civic", "Element", "Insight", "Pilot", "S2000"],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "Tucson",
          "XG350",
        ],
        Infiniti: ["FX35", "G35", "G35 Coupe"],
        Jaguar: ["XJ", "XK"],
        Jeep: [
          "Grand Cherokee",
          "Liberty",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Sorento", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["Aviator", "Navigator"],
        Mazda: ["MAZDA3", "MAZDA6", "Miata", "Tribute"],
        Mercedes: [
          "C-Class C230",
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Titan",
          "Xterra",
        ],
        Pontiac: ["Firebird", "G6", "GTO", "Grand Am", "Grand Prix", "Vibe"],
        Ram: ["1500", "2500", "3500", "Dakota"],
        Saab: ["9 3", "9 5", "9-2x"],
        Saturn: ["ION", "VUE"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tundra",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2e3: {
        Ram: [
          "1500",
          "2500",
          "3500",
          "Dakota",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Mercedes: [
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
        ],
        Acura: ["Integra", "NSX", "RL", "TL"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "TT",
        ],
        BMW: [
          "323Ci",
          "323Ci Convertible/Coupe",
          "323i Sedan",
          "323iT Wagon",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "328Ci Coupe",
          "328i Sedan",
          "540i Wagon",
          "740iL",
          "750iL",
          "Ci Convertible/Coupe",
          "X5",
        ],
        Buick: ["LeSabre", "Regal"],
        Cadillac: ["Deville", "Eldorado", "Escalade"],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Suburban",
          "Tahoe",
        ],
        Chrysler: ["Sebring Convertible", "Sebring Coupe"],
        Dodge: ["Dakota", "Durango", "Ram 1500", "Ram 2500", "Ram 3500"],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
        ],
        GMC: ["Envoy", "Sierra 1500"],
        Hyundai: ["Accent", "Elantra", "Sonata", "Tiburon"],
        Honda: ["Accord", "Insight", "S2000"],
        Hyundai: ["Accent", "Elantra", "Sonata", "Tiburon"],
        Jaguar: ["XJ", "XK"],
        Jeep: ["Grand Cherokee"],
        Kia: ["Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: ["ES", "GS", "LS", "LX", "RX", "SC"],
        Lincoln: ["Navigator"],
        Mazda: ["Miata"],
        "Mercedes-Benz": [
          "E-Class (All Except Convertible)",
          "M Class",
          "SL Class",
        ],
        Mitsubishi: ["Eclipse", "Galant", "Lancer"],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Dodge: ["1500", "2500", "3500", "Dakota"],
        Subaru: ["Forester", "Impreza", "Legacy", "Outback"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "RAV4",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tundra",
        ],
        Volkswagen: ["Beetle", "Golf", "Golf GTI", "Jetta", "Passat"],
        Volvo: ["C70", "S40", "S60", "S80"],
      },
      2008: {
        Maserati: ["GranTurismo", "Quattroporte"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q7",
          "S4 Cabriolet",
          "S4 Sedan",
          "S5",
          "S6",
          "S8",
          "TT",
          "iTT",
        ],
        BMW: [
          "1 Series",
          "328i Convertible/Coupe",
          "328i Sedan",
          "328i Wagon",
          "328xi Coupe",
          "328xi Sedan",
          "328xi Wagon",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335xi Coupe",
          "335xi Sedan",
          "528xi",
          "535xi Wagon",
          "750Li",
          "750i",
          "760Li",
          "Alpina B7",
          "X5",
          "X6 xDrive 35i",
        ],
        Buick: ["Enclave", "La Crosse", "Lucerne"],
        Cadillac: ["CTS Sedan", "DTS", "Escalade", "SRX", "STS"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Trailblazer",
        ],
        Dodge: [
          "Avenger",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "Civic",
          "Element",
          "Fit",
          "Pilot",
          "Ridgeline",
          "S2000",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "Tucson",
          "Vera Cruz",
        ],
        Infiniti: [
          "EX35",
          "FX35",
          "G35 Coupe",
          "G35 Sedan",
          "G37 Convertible/Coupe",
          "M35",
        ],
        Jaguar: ["XJ", "XK"],
        Jeep: [
          "Commander",
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Rio", "Rio", "Sorento", "Spectra", "Sportage"],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Sport",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["MKX", "MKZ", "Navigator"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C300",
          "CL-Class",
          "CLK Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "GL Class",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper", "Cooper Clubman"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["G6", "G8", "Grand Prix", "Soltice", "Vibe"],
        Ram: ["1500", "2500", "3500", "3500 Chassis", "4500 Chassis", "Dakota"],
        Saab: ["9 3", "9 5", "9-3 SportCombi", "9-7x"],
        Saturn: ["Aura", "Sky", "VUE"],
        Scion: ["tC"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tundra",
        ],
        Volkswagen: ["Beetle", "Eos", "Golf", "Golf GTI", "Jetta", "Passat"],
        Volvo: ["C30", "C70", "S40", "S60", "S80", "XC70", "XC90"],
        Saab: ["9 3", "9 5", "9-3 SportCombi", "9-7x"],
      },
      2009: {
        Ram: ["1500", "2500", "3500", "3500 Chassis", "Dakota"],
        Chrysler: [
          "300",
          "PT Cruiser",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Maserati: ["GranTurismo", "Quattroporte"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "S4 Cabriolet",
          "S4 Sedan",
          "S5",
          "S6",
          "S8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Convertible/Coupe",
          "328i Coupe",
          "328i Sedan",
          "328i Wagon",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "335d Sedan",
          "335i Convertible/Coupe",
          "335i Sedan",
          "535xi Wagon",
          "750Li",
          "750i",
          "760Li",
          "Alpina B7",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: ["Enclave", "La Crosse", "Lucerne"],
        Cadillac: ["CTS Sedan", "Deville", "DTS", "Escalade", "SRX", "STS"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Trailblazer",
          "Traverse",
        ],
        Dodge: [
          "Avenger",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "Civic",
          "Element",
          "Fit",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Vera Cruz",
        ],
        Infiniti: ["EX35", "FX35", "G37 Convertible/Coupe", "G37 Sedan", "M35"],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Commander",
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Optima",
          "Rio",
          "Rio5",
          "Sedona",
          "Sorento",
          "Spectra",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Sport",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["MKS", "MKX", "MKZ", "Navigator"],
        Maserti: ["GranTurismo", "Quattroporte"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "GL Class",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper", "Cooper Clubman"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "350Z",
          "370Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["G6", "G8", "Solstice", "Vibe"],
        Saturn: ["Aura", "Sky", "VUE"],
        Scion: ["tC"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "Rav4",
          "Sequoia",
          "Sequoia Platinum",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta Sportwagen",
          "Passat",
          "Routan",
          "Tiguan",
        ],
        Volvo: ["C30", "C70", "S40", "S60", "S80", "XC70", "XC90"],
      },
      2010: {
        Chrysler: [
          "300",
          "PT Crusier",
          "Sebring Convertible",
          "Sebring Coupe",
          "Sebring Sedan",
        ],
        Maserati: ["GranTurismo", "Quattroporte"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX", "ZDX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "S4 Sedan",
          "S5",
          "S6",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Coupe",
          "328i Convertible/Coupe",
          "328i Sedan",
          "328i Wagon",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "335d Sedan",
          "335i Convertible/Coupe",
          "335i Sedan",
          "550i",
          "750Li",
          "750i",
          "760Li",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: ["Enclave", "La Crosse", "Lucerne"],
        Cadillac: ["Deville", "Eldorado", "Escalade"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Cobalt Sedan",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Traverse",
        ],
        Dodge: [
          "Avenger",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "Civic",
          "Element",
          "Fit",
          "Insight",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Vera Cruz",
        ],
        Infiniti: [
          "EX35",
          "FX35",
          "G37 Convertible/Coupe",
          "G37 Sedan",
          "M35",
          "QX56",
        ],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Commander",
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Forte",
          "Forte Koup",
          "Optima",
          "Rio",
          "Sedona",
          "Sorento",
          "Soul",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover Evoque",
          "Range Rover LR4",
          "Range Rover Sport",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "HS",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
        ],
        Lincoln: ["MKS", "MKT", "MKX", "MKZ", "Navigator"],
        Lotus: ["Exige", "Evora"],
        Maserti: ["GranTurismo", "Quattroporte"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper", "Cooper Clubman"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
        ],
        Nissan: [
          "370Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "G6", "Grand Am", "Grand Prix", "Vibe"],
        Ram: ["1500", "2500", "3500", "3500 Chassis", "4500 Chassis"],
        Saab: ["9 3", "9 5", "9-3 SportCombi"],
        Saturn: ["VUE"],
        Scion: ["tC"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta Sportwagen",
          "Passat",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80"],
      },
      2011: {
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX", "ZDX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "S4 Sedan",
          "S5",
          "S6",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "328i Convertible/Coupe",
          "328i Coupe",
          "328i Sedan",
          "328i Wagon",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "335d Sedan",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335is Convertible/Coupe",
          "528i Sedan",
          "535i Sedan",
          "550i",
          "740Li",
          "740i",
          "750Li",
          "750i",
          "760Li",
          "Alpina B7",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: ["LeSabre", "Regal", "Enclave", "La Crosse", "Lucerne"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "CTS Coupe",
          "CTS Sedan",
          "DTS",
          "SRX",
          "STS",
        ],
        Lincoln: ["Navigator", "MKS", "MKT", "MKX", "MKZ"],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Volt",
        ],
        Dodge: [
          "200 Convertible",
          "200 Sedan",
          "300",
          "Avenger",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: ["Accord", "Insight", "S2000"],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Vera Cruz",
        ],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: ["ES", "GS", "IS", "IS Convertible", "LS", "LX", "RX", "SC"],

        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA2",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "G Class",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "Dakota",
        ],
        Saab: ["9 3", "9 5", "9-3 SportCombi", "9-4x"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta Sportwagen",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C30", "C70", "S40", "S60", "S80", "XC60", "XC70", "XC90"],
      },
      2020: {
        Acura: ["ILX", "MDX", "NSX", "RDX", "RLX", "TLX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A5 Sportback",
          "A6",
          "A6 Allroad",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "E-Tron",
          "Q3",
          "Q5",
          "Q7",
          "Q8",
          "RS Q8",
          "RS3",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "SQ8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "120 Ah",
          "2 Series Convertible/Coupe",
          "2 Series Gran Coupe",
          "300e Hybrid",
          "330e",
          "330i Sedan",
          "430i xDrive Coupe",
          "440i Coupe",
          "440i xDrive Coupe",
          "530e",
          "530i",
          "540i Sedan",
          "550i",
          "740i",
          "745e xDrive",
          "750Li",
          "750i",
          "840i",
          "Alpina B7",
          "I8",
          "M2",
          "M340i Sedan",
          "M550i",
          "M760i xDrive",
          "M8",
          "M850i",
          "X1 28i",
          "X2 28i",
          "X2 M35i",
          "X2 xDrive28i",
          "X3 30i",
          "X3 M35i",
          "X3 M40i",
          "X4",
          "X4 M",
          "X5",
          "X5 40i",
          "X6",
          "X7",
        ],
        Buick: ["Enclave", "Encore", "Envision", "Regal Sportback"],
        Chrysler: ["300"],
        Cadillac: ["CT4", "CT5", "CT6", "Escalade", "XT4", "XT5", "XT6"],
        Chevrolet: [
          "Blazer",
          "Bolt",
          "Camaro",
          "Colorado",
          "Corvette",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Trax",
        ],
        Chrysler: ["300"],
        Dodge: [
          "Challenger",
          "Charger",
          "Durango",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "E Series",
          "EcoSport",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT350",
          "Shelby GT500",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G70", "G80", "G90"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "Clarity Hybrid",
          "Fit",
          "HR-V",
          "Insight",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Ioniq",
          "Kona",
          "Nexo",
          "Palisade",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster GL, Premium, SE, Turbo",
          "Veloster N",
          "Venue",
        ],
        Infiniti: ["Q50", "Q60", "QX50", "QX60", "QX80"],
        Jaguar: ["E-PACE", "F-PACE", "F-type", "I-PACE", "XE", "XF"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Gladiator",
          "Grand Cherokee",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Cadenza",
          "Forte",
          "Niro",
          "Optima",
          "Rio",
          "Sorento",
          "Soul",
          "Sportage",
          "Stinger",
          "Telluride",
        ],
        "Land Rover": [
          "Defender",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SE",
          "Range Rover Evoque SVR",
          "Range Rover SV",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Sport SVR",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LC",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
          "UX",
        ],
        Lincoln: ["Aviator", "Corsair", "MKZ", "Nautilus", "Navigator"],
        Maserati: ["Ghibli", "Levante", "Quattroporte"],
        Mazda: ["CX-3", "CX-30", "CX-5", "CX-9", "MAZDA3", "MAZDA6", "Miata"],
        Mercedes: [
          "A-Class",
          "AMG GT53",
          "AMG GT63",
          "C-Class AMG",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "G Class",
          "GLA Class",
          "GLB Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "SL Class",
          "SLC Class",
          "Sprinter",
        ],
        Mini: [
          "Cooper",
          "Cooper Clubman",
          "Cooper Countryman",
          "Cooper Countryman Hybrid",
        ],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Subaru: [
          "Ascent",
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Avalon",
          "C-HR",
          "Camry",
          "Corolla",
          "GR86",
          "Highlander",
          "Mirai",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Supra",
          "Tacoma",
          "Tundra",
          "Yaris",
        ],
        Volkswagen: [
          "Arteon",
          "Atlas",
          "Atlas Cross Sport",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Tiguan",
        ],
        Volvo: ["S60", "S90", "V60", "V90", "XC40", "XC60", "XC90"],
      },
      2019: {
        Acura: ["ILX", "MDX", "NSX", "RDX", "RLX", "TLX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A5 Sportback",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "E-Tron",
          "Q3",
          "Q5",
          "Q7",
          "Q8",
          "RS3",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "SQ5",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "120 Ah",
          "2 Series Convertible/Coupe",
          "300e Hybrid",
          "330e",
          "330i Sedan",
          "330i Wagon",
          "340i Sedan",
          "430i xDrive Coupe",
          "440i Coupe",
          "440i xDrive Coupe",
          "530e",
          "530i",
          "540i Sedan",
          "550i",
          "640i Gran Coupe",
          "740e xDrive",
          "740i",
          "750Li",
          "750i",
          "94 AH",
          "Alpina B6",
          "Alpina B7",
          "I8",
          "M2",
          "M550i",
          "M6",
          "M760i xDrive",
          "X1 28i",
          "X2 28i",
          "X2 M35i",
          "X2 xDrive28i",
          "X3 30i",
          "X3 M40i",
          "X4",
          "X5",
          "X5 40i",
          "X6",
          "X6 xDrive 35i",
          "X7",
        ],
        Buick: [
          "Enclave",
          "Encore",
          "Envision",
          "La Crosse",
          "Regal Sportback",
        ],
        Chrysler: ["300"],
        Cadillac: [
          "ATS Coupe",
          "CT6",
          "CTS Sedan",
          "Escalade",
          "XT4",
          "XT5",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Bolt",
          "Camaro",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Trax",
          "Volt",
        ],
        Chrysler: ["300"],
        Dodge: [
          "Challenger",
          "Charger",
          "Durango",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "E Series",
          "EcoSport",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT350",
          "Taurus",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Genesis: ["G70", "G80", "G90"],
        Honda: [
          "Accord",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "Clarity Hybrid",
          "Fit",
          "HR-V",
          "Insight",
          "Passport",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Ioniq",
          "Kona",
          "Nexo",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
        ],
        Infiniti: ["Q50", "Q60", "Q70", "QX30", "QX50", "QX60", "QX80"],
        Jaguar: ["E-PACE", "F-PACE", "F-type", "I-PACE", "XE", "XF", "XJ"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Grand Cherokee",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Cadenza",
          "Forte",
          "Niro",
          "Optima",
          "Rio",
          "Sorento",
          "Soul",
          "Sportage",
          "Stinger",
        ],
        "Land Rover": [
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SE",
          "Range Rover Evoque SVR",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LC",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
          "UX",
        ],
        Lincoln: ["MKC", "MKT", "MKZ", "Nautilus", "Navigator"],
        Maserati: ["Ghibli", "GranTurismo", "Levante", "Quattroporte"],
        Mazda: ["CX-3", "CX-5", "CX-9", "MAZDA3", "MAZDA6", "Miata"],
        Mercedes: [
          "A-Class",
          "AMG GT53",
          "AMG GT63",
          "C-Class AMG",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "G Class",
          "GLA Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 450",
          "S-Class 560",
          "SL Class",
          "SLC Class",
          "Sprinter",
        ],
        Mini: [
          "Cooper",
          "Cooper Clubman",
          "Cooper Countryman",
          "Cooper Countryman Hybrid",
        ],
        Mitsubishi: [
          "Eclipse Cross",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Sedan",
          "Armada",
          "Frontier",
          "GT-R",
          "Kicks",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        Subaru: [
          "Ascent",
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Avalon",
          "C-HR",
          "Camry",
          "Corolla",
          "GR86",
          "Highlander",
          "Mirai",
          "Prius",
          "Prius Prime",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tundra",
          "YARiS",
        ],
        Volkswagen: [
          "Arteon",
          "Atlas",
          "Beetle",
          "Golf",
          "Golf Alltrack",
          "Golf GTI",
          "Golf R Coupe",
          "Golf R Sedan",
          "Golf Sportwagen",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Tiguan",
          "e-Golf",
        ],
        Volvo: ["S60", "S90", "V60", "V90", "XC40", "XC60", "XC90"],
      },
      2011: {
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Infiniti: [
          "EX35",
          "FX35",
          "G25",
          "G37 Convertible/Coupe",
          "G37 Sedan",
          "M37",
          "QX56",
        ],
        Scion: ["tC"],
        Maserati: ["GranTurismo", "Quattroporte"],
        Mini: ["Cooper", "Cooper Clubman", "Cooper Countryman"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX", "ZDX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "S4 Sedan",
          "S5",
          "S6",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "328i Convertible/Coupe",
          "328i Coupe",
          "328i Sedan",
          "328i Wagon",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "335d Sedan",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335is Convertible/Coupe",
          "528i Sedan",
          "535i Sedan",
          "550i",
          "740Li",
          "740i",
          "750Li",
          "750i",
          "760Li",
          "Alpina B7",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: ["LeSabre", "Regal", "Enclave", "La Crosse", "Lucerne"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "CTS Coupe",
          "CTS Sedan",
          "DTS",
          "SRX",
          "STS",
        ],
        Chevrolet: [
          "Avalanche",
          "Aveo",
          "Blazer",
          "Camaro",
          "Caprice",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "HHR",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Volt",
        ],
        Dodge: [
          "200 Convertible",
          "200 Sedan",
          "300",
          "Avenger",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Nitro",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: ["Accord", "Insight", "S2000"],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Vera Cruz",
        ],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Spectra", "Sportage"],
        "Land Rover": ["Range Rover"],
        Lexus: ["ES", "GS", "IS", "IS Convertible", "LS", "LX", "RX", "SC"],
        Lincoln: ["Navigator", "MKS", "MKT", "MKX", "MKZ"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA2",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "E-Class (All Except Convertible)",
          "G Class",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Outlander",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "Dakota",
        ],
        Saab: ["9 3", "9 5", "9-3 SportCombi", "9-4x"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta Sportwagen",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C30", "C70", "S40", "S60", "S80", "XC60", "XC70", "XC90"],
      },
      2012: {
        Scion: ["tC"],
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Mini: ["Cooper", "Cooper Clubman", "Cooper Countryman"],
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "TSX", "ZDX"],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "S4 Sedan",
          "S5",
          "S6",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "328i Convertible/Coupe",
          "328i Coupe",
          "328i Sedan",
          "328i Wagon",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335is Convertible/Coupe",
          "528i Sedan",
          "535i Sedan",
          "550i",
          "640i Gran Coupe",
          "740Li",
          "740i",
          "750Li",
          "750i",
          "760Li",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: ["Enclave", "La Crosse", "Regal", "Verano"],
        Cadillac: [
          "CTS Coupe",
          "CTS Sedan",
          "Deville",
          "Eldorado",
          "Escalade",
          "SRX",
        ],
        Chevrolet: [
          "Avalanche",
          "Blazer",
          "Camaro",
          "Caprice",
          "Captiva",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Sonic",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Volt",
        ],
        Dodge: [
          "200 Convertible",
          "200 Sedan",
          "300",
          "Avenger",
          "C/V",
          "Caliber",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
          "Ram C/V",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "CR-Z",
          "Civic",
          "Crosstour",
          "Fit",
          "Insight",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
          "Vera Cruz",
        ],
        Infiniti: [
          "EX35",
          "FX35",
          "G25",
          "G37 Convertible/Coupe",
          "G37 Sedan",
          "M37",
          "QX56",
        ],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Compass",
          "Grand Cherokee",
          "Liberty",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: ["Optima", "Spectra", "Sportage"],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover LR4",
          "Range Rover Sport",
        ],
        Lexus: [
          "CT",
          "ES",
          "GX",
          "HS",
          "IS",
          "IS Convertible",
          "LFA",
          "LS",
          "LX",
          "RX",
        ],
        Lincoln: ["MKS", "MKT", "MKX", "MKZ", "Navigator"],
        Maserati: ["GranTurismo", "Quattroporte"],
        Mazda: [
          "CX-7",
          "CX-9",
          "MAZDA2",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C250",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 350",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Mirage",
          "Outlander",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Coupe",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "C/V",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: ["Forester", "Impreza", "Legacy", "Outback", "WRX"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Golf R Coupe",
          "Golf R Sedan",
          "Jetta",
          "Jetta GLI, Sportwagen",
          "Passat",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C30", "C70", "S60", "S80", "XC60", "XC70", "XC90"],
      },
      2013: {
        Scion: ["tC"],
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Acura: [
          "CL",
          "Integra",
          "MDX",
          "NSX",
          "RL",
          "TL",
          "ILX",
          "RDX",
          "TSX",
          "ZDX",
        ],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "RS5",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "320i Sedan",
          "328i Convertible/Coupe",
          "328i Coupe",
          "328i Sedan",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Coupe",
          "335i Convertible/Coupe",
          "335i Sedan",
          "335is Convertible/Coupe",
          "528i Sedan",
          "535i Sedan",
          "550i",
          "640i Gran Coupe",
          "740Li",
          "740i",
          "750Li",
        ],
        Buick: ["LeSabre", "Regal", "Enclave", "Encore", "La Crosse", "Verano"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "ATS Sedan",
          "CTS Coupe",
          "CTS Sedan",
          "SRX",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Caprice",
          "Captiva",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Volt",
        ],
        Dodge: [
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
          "Ram C/V",
          "Avenger",
          "C/V",
          "Challenger",
          "Charger",
          "Dart",
        ],
        Ford: [
          "C-Max",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Shelby GT500",
          "Taurus",
        ],
        GMC: [
          "Acadia",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "CR-Z",
          "Civic",
          "Crosstour",
          "Fit",
          "Insight",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Elantra Coupe",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
        ],
        Infiniti: ["G37 Convertible/Coupe", "G37 Sedan", "JX35", "M37", "QX56"],
        Jaguar: ["XF", "XJ", "XK"],
        Jeep: [
          "Compass",
          "Grand Cherokee",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Forte",
          "Forte Koup",
          "Forte5",
          "Optima",
          "Rio",
          "Sorento",
          "Soul",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover LR4",
          "Range Rover Sport",
        ],
        Lexus: [
          "CT",
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
        ],
        Lincoln: ["Navigator", "MKS", "MKT", "MKX", "MKZ"],
        Maserati: ["GranTurismo", "Quattroporte"],
        Mazda: [
          "CX-5",
          "CX-9",
          "MAZDA2",
          "MAZDA3",
          "MAZDA6",
          "MAZDASPEED3",
          "Miata",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C250",
          "C-Class C300",
          "CL-Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "G Class",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 350",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mini: ["Cooper", "Cooper Clubman", "Cooper Countryman"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Mirage",
          "Outlander",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "C/V",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Matrix",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tundra",
          "Venza",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Golf R Coupe",
          "Golf R Sedan",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C30", "C70", "S40", "S60", "S80"],
      },
      2014: {
        Scion: ["tC"],
        Mini: ["Cooper", "Cooper Clubman", "Cooper Countryman"],
        Maserati: ["Ghibli", "GranTurismo", "Quattroporte"],
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Acura: [
          "CL",
          "Integra",
          "MDX",
          "NSX",
          "RL",
          "TL",
          "ILX",
          "RDX",
          "RLX",
          "TSX",
        ],
        Audi: [
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "Q5",
          "Q7",
          "RS5",
          "RS7",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "1 Series",
          "2 Series Convertible/Coupe",
          "320i Sedan",
          "328 Wagon",
          "328d Sedan",
          "328i Convertible/Coupe",
          "328i Sedan",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "335i Sedan",
          "428i Coupe",
          "435i Coupe",
          "528i Sedan",
          "535d",
          "535i Sedan",
          "550i",
          "640i Gran Coupe",
          "740Li",
          "740i",
          "750Li",
          "750i",
          "760Li",
          "Alpina B6",
          "Alpina B7",
          "M6",
          "X1 28i",
          "X1 35i",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X3 xDrive28i",
          "X5",
          "X6",
          "X6 xDrive 35i",
          "i3",
        ],
        Buick: ["Enclave", "Encore", "La Crosse", "Regal", "Verano"],
        Cadillac: ["Deville", "Eldorado", "Escalade"],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Caprice",
          "Captiva",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Volt",
        ],
        Dodge: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "C/V",
          "Dakota",
          "Durango",
          "ProMaster",
          "ProMaster Chassis",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram C/V",
        ],
        Ford: [
          "C-Max",
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Shelby GT500",
          "Taurus",
          "Ranger",
        ],
        GMC: [
          "Acadia",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "CR-Z",
          "Civic",
          "Crosstour",
          "Fit",
          "Insight",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Elantra Coupe",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
        ],
        Infiniti: ["Q50", "Q60", "Q70", "QX50", "QX60", "QX70", "QX80"],
        Jaguar: ["F-type", "XF", "XJ", "XK"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Grand Cherokee",
          "Patriot",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Cadenza",
          "Forte",
          "Forte Koup",
          "Forte5",
          "Optima",
          "Rio",
          "Sorento",
          "Soul",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover LR4",
          "Range Rover Sport",
          "Range Rover Sport SE",
        ],
        Lexus: [
          "CT",
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
        ],
        Lincoln: ["MKS", "MKT", "MKX", "MKZ", "Navigator"],
        Mazda: [
          "BRZ",
          "CX-5",
          "CX-9",
          "MAZDA2",
          "MAZDA3",
          "MAZDA6",
          "Miata",
          "Tribute",
        ],
        Mercedes: [
          "C-Class AMG",
          "C-Class C250",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "GL Class",
          "GLK",
          "M Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Mirage",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Sedan",
          "Armada",
          "Cube",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "C/V",
          "ProMaster",
          "ProMaster Chassis",
        ],
        Saturn: ["200 Convertible", "200 Sedan", "300"],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "FJ Cruiser",
          "Highlander",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tundra",
          "Venza",
          "YARiS",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Jetta GLI, Sportwagen",
          "Passat",
          "Routan",
          "Tiguan",
          "Touareg",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "XC60", "XC70", "XC90"],
      },
      2015: {
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Scion: ["tC"],
        Acura: [
          "CL",
          "Integra",
          "MDX",
          "NSX",
          "RL",
          "TL",
          "ILX",
          "RDX",
          "RLX",
          "TLX",
        ],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Sedan",
          "S4 Cabriolet",
          "S8",
          "TT",
          "A3",
          "A3 Cabriolet",
          "A5",
          "A7",
          "Q3",
          "Q5",
          "Q7",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S5",
          "S6",
          "S7",
          "SQ5",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "335i Sedan",
          "328 Wagon",
          "328d Sedan",
          "335i Sedan",
          "428i Coupe",
          "428i xDrive Coupe",
          "435i Coupe",
          "528i Sedan",
          "535d",
          "535i Sedan",
          "550i",
          "640i Gran Coupe",
          "740 Ld",
          "740Li",
          "740i",
          "750Li",
          "750i",
          "760Li",
          "Alpina B6",
          "Alpina B7",
          "M6",
          "X1 28i",
          "X1 35i",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X3 xDrive28d",
          "X3 xDrive28i",
          "X4",
          "X5",
          "X6",
          "X6 xDrive 35i",
          "i3",
        ],
        Buick: ["LeSabre", "Regal", "Enclave", "Encore", "La Crosse", "Verano"],
        Chrysler: ["300"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "ATS Coupe",
          "ATS Sedan",
          "CTS Sedan",
          "SRX",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Caprice",
          "Captiva",
          "City Express",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Trax",
          "Volt",
        ],
        Dodge: [
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "C/V",
          "Challenger",
          "Charger",
          "Dart",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Focus",
          "Fusion",
          "Mustang",
          "Ranger",
          "Shelby GT500",
          "Taurus",
          "Transit",
          "C-Max",
          "Edge",
          "Fiesta",
          "Flex",
        ],
        GMC: [
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Acadia",
          "Canyon",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-V",
          "CR-Z",
          "Civic",
          "Crosstour",
          "Fit",
          "Pilot",
          "Insight",
          "S2000",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
        ],
        Infiniti: ["Q50", "Q60", "Q70", "QX50", "QX60", "QX70", "QX80"],
        Jaguar: ["XJ", "XF", "XK", "F-type"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Grand Cherokee",
          "Patriot",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Cadenza",
          "Forte",
          "Forte Koup",
          "Forte5",
          "Optima",
          "Rio",
          "Sedona",
          "Sorento",
          "Soul",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover Evoque",
          "Range Rover Evoque SVR",
          "Range Rover LR4",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Sport SVR",
        ],
        Lexus: [
          "ES",
          "GS",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "NX",
          "RX",
          "SC",
          "RC, F",
        ],
        Lincoln: ["Navigator", "MKC", "MKS", "MKT", "MKX", "MKZ"],
        Maserati: ["Ghibli", "GranTurismo", "Quattroporte"],
        Mazda: ["Miata", "Tribute", "CX-5", "CX-9", "MAZDA3", "MAZDA6"],
        Mercedes: [
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "C-Class AMG",
          "C-Class C250",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "CLS Class AMG",
          "G Class",
          "GL Class",
          "GLA Class",
          "GLK",
          "S-Class 550",
          "SLK",
          "SLK Class",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Armada",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
          "Xterra",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "C/V",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
          "Venza",
          "YARiS",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Golf R Coupe",
          "Golf R Sedan",
          "Golf Sportwagen",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Tiguan",
          "Touareg",
          "e-Golf",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "V60", "XC60", "XC70", "XC90"],
      },
      2016: {
        Chrysler: ["200 Convertible", "200 Sedan", "300"],
        Acura: [
          "CL",
          "Integra",
          "MDX",
          "NSX",
          "RL",
          "TL",
          "ILX",
          "RDX",
          "RLX",
          "TLX",
        ],
        Audi: [
          "A3",
          "A3 Cabriolet",
          "A4",
          "A4 Cabriolet",
          "A5",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A7",
          "A8",
          "A8 W12",
          "Q3",
          "Q5",
          "Q7",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S4 Sedan",
          "S5",
          "S6",
          "S7",
          "S8",
          "SQ5",
          "TT",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "2 Series Convertible/Coupe",
          "300e Hybrid",
          "320i Sedan",
          "328 Wagon",
          "328d Sedan",
          "328i Sedan",
          "328i xDrive Sedan",
          "328i xDrive Wagon",
          "328xi Sedan",
          "330e",
          "340i Sedan",
          "428i Coupe",
          "428i xDrive Coupe",
          "435i Coupe",
          "528i Sedan",
          "535d",
          "535i Sedan",
          "540i Sedan",
          "550i",
          "640i Gran Coupe",
          "740i",
          "750Li",
          "750i",
          "Alpina B6",
          "Alpina B7",
          "M2",
          "M6",
          "X1 28i",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X3 xDrive28d",
          "X3 xDrive28i",
          "X4",
          "X5",
          "X6",
          "X6 xDrive 35i",
          "i3",
        ],
        Buick: [
          "LeSabre",
          "Regal",
          "Enclave",
          "Encore",
          "Envision",
          "La Crosse",
          "Verano",
        ],
        Chrysler: ["300"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "ATS Coupe",
          "ATS Sedan",
          "CT6",
          "CTS Sedan",
          "SRX",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Caprice",
          "City Express",
          "Colorado",
          "Corvette",
          "Cruze",
          "Equinox",
          "Express",
          "Impala",
          "Malibu",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500 HD",
          "Silverado 3500 HD Chassis",
          "Sonic",
          "Spark",
          "Suburban",
          "Tahoe",
          "Traverse",
          "Trax",
          "Volt",
        ],
        Dodge: [
          "200 Convertible",
          "200 Sedan",
          "300",
          "Challenger",
          "Charger",
          "Dakota",
          "Durango",
          "Dart",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "C-Max",
          "Crown Victoria",
          "E Series",
          "Edge",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "F-450",
          "Fiesta",
          "Flex",
          "Focus",
          "Fusion",
          "Mustang",
          "Shelby GT350",
          "Shelby GT500",
          "Taurus",
          "Transit",
        ],
        GMC: [
          "Acadia",
          "Canyon",
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "CR-Z",
          "Civic",
          "Fit",
          "HR-V",
          "Insight",
          "Pilot",
          "S2000",
        ],
        Hyundai: [
          "Accent",
          "Azera",
          "Elantra",
          "Equus",
          "Santa Fe",
          "Sonata",
          "Tucson",
          "Veloster",
        ],
        Infiniti: ["Q50", "Q60", "Q70", "QX50", "QX60", "QX70", "QX80"],
        Jaguar: ["F-type", "XF", "XJ"],
        Jeep: [
          "Cherokee",
          "Compass",
          "Grand Cherokee",
          "Patriot",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Cadenza",
          "Forte",
          "Forte Koup",
          "Forte5",
          "Optima",
          "Rio",
          "Sedona",
          "Sorento",
          "Soul",
          "Sportage",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SVR",
          "Range Rover LR4",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Sport SVR",
        ],
        Lexus: [
          "CT",
          "ES",
          "GS",
          "GX",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "NX",
          "RC, F",
          "RX",
        ],
        Lincoln: ["MKC", "MKS", "MKT", "MKX", "MKZ", "Navigator"],
        " Maserati": ["Ghibli", "GranTurismo", "Quattroporte"],
        " Mazda": ["BRZ", "CX-3", "CX-5", "CX-9", "MAZDA3", "MAZDA6", "Miata"],
        Mercedes: [
          "C-Class AMG",
          "C-Class C240",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "CLS Class AMG",
          "E-Class (All Except Convertible)",
          "G Class",
          "GL Class",
          "GLA Class",
          "GLC Class",
          "GLE Class",
          "S-Class 550",
          "SL Class",
          "SLK",
          "SLK Class",
          "Sprinter",
        ],
        Mini: ["Cooper", "Cooper Clubman", "Cooper Countryman"],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Lancer Evolution",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "370Z",
          "Altima Sedan",
          "Frontier",
          "GT-R",
          "Juke",
          "Leaf",
          "Maxima",
          "Murano",
          "Pathfinder",
          "Quest",
          "Rogue",
          "Sentra",
          "Titan",
          "Versa",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "BRZ",
          "Crosstrek",
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "WRX",
        ],
        Tesla: ["Model X"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "Mirai",
          "Prius",
          "RAV4",
          "Sequoia",
          "Sequoia Platinum",
          "Sienna",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
          "Venza",
          "YARiS",
        ],
        Volkswagen: [
          "Beetle",
          "CC",
          "Eos",
          "Golf",
          "Golf GTI",
          "Golf R Coupe",
          "Golf R Sedan",
          "Golf Sportwagen",
          "Jetta",
          "Jetta GLI",
          "Passat",
          "Tiguan",
          "Touareg",
          "e-Golf",
        ],
        Volvo: ["C70", "S40", "S60", "S80", "V60", "XC60", "XC70", "XC90"],
      },
      2018: {
        Acura: [
          "CL",
          "Integra",
          "MDX",
          "NSX",
          "RL",
          "TL",
          "ILX",
          "RDX",
          "RLX",
          "TLX",
        ],
        Genesis: ["G80", "G90"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "S8",
          "TT",
          "A3",
          "A3 Cabriolet",
          "A5",
          "A5 Sportback",
          "A7",
          "Q3",
          "Q5",
          "Q7",
          "RS3",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S5",
          "S6",
          "S7",
          "SQ5",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "540i Wagon",
          "740iL",
          "750iL",
          "Ci Convertible/Coupe",
          "X5",
          "2 Series Convertible/Coupe",
          "300e Hybrid",
          "320i Sedan",
          "328 Wagon",
          "328d Sedan",
          "330e",
          "330i Sedan",
          "330i Wagon",
          "340i Sedan",
          "430i xDrive Coupe",
          "440i Coupe",
          "440i xDrive Coupe",
          "530e",
          "530i",
          "540d",
          "540i Sedan",
          "550i",
          "640i Gran Coupe",
          "740e xDrive",
          "740i",
          "750Li",
          "750i",
          "94 AH",
          "Alpina B6",
          "Alpina B7",
          "M2",
          "M550i",
          "M6",
          "M760i xDrive",
          "X1 28i",
          "X2 28i",
          "X2 xDrive28i",
          "X3 M40i",
          "X4",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: [
          "LeSabre",
          "Regal",
          "Enclave",
          "Encore",
          "Envision",
          "La Crosse",
          "Regal Sportback",
        ],
        Chrysler: ["300"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "ATS Coupe",
          "ATS Sedan",
          "CT6",
          "CTS Sedan",
          "XT5",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Bolt",
          "City Express",
          "Colorado",
          "Cruze",
          "Equinox",
          "Sonic",
          "Spark",
          "Traverse",
          "Trax",
          "Volt",
        ],
        Dodge: [
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Challenger",
          "Charger",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500 Chassis",
          "Ram 4500 Chassis",
          "Ram 5500 Chassis",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
          "C-Max",
          "EcoSport",
          "Edge",
          "Fiesta",
          "Flex",
          "Fusion",
          "Shelby GT350",
          "Transit",
        ],
        GMC: [
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Acadia",
          "Canyon",
          "Sierra 3500HD",
          "Terrain",
          "Yukon",
        ],
        Honda: [
          "Accord",
          "Insight",
          "S2000",
          "CR-V",
          "Civic (All Except SI)",
          "Civic SI",
          "Clairity Hybrid",
          "Fit",
          "HR-V",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG300",
          "Ioniq",
          "Kona",
          "Tucson",
        ],
        Infiniti: ["G80", "G90", "Q50", "Q60", "Q70", "QX30", "QX60", "QX80"],
        Jaguar: ["XJ", "XK", "E-PACE", "F-PACE", "F-type", "XE", "XF"],
        Jeep: [
          "Grand Cherokee",
          "Cherokee",
          "Compass",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Optima",
          "Spectra",
          "Sportage",
          "Cadenza",
          "Forte",
          "Forte5",
          "Niro",
          "Rio",
          "Sorento",
          "Soul",
          "Stinger",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover Evoque",
          "Range Rover Evoque SE",
          "Range Rover Evoque SVR",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Sport SVR",
          "Range Rover Velar",
        ],
        Lexus: [
          "ES",
          "GS",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
          "GX",
          "NX",
          "RC, F",
        ],
        Lincoln: ["Navigator", "MKC", "MKT", "MKX", "MKZ"],
        Maserati: ["Ghibli", "GranTurismo", "Levante", "Quattroporte"],
        Mazda: ["Miata", "Tribute", "CX-3", "CX-5", "CX-9", "MAZDA3", "MAZDA6"],
        Mercedes: [
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "C-Class AMG",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "G Class",
          "GLA Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 450",
          "S-Class 560",
          "SLC Class",
          "Sprinter",
        ],
        Mitsubishi: ["Eclipse", "Galant", "Lancer"],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
          "370Z",
          "Armada",
          "GT-R",
          "Kicks",
          "Leaf",
          "Murano",
          "Rogue",
          "Titan",
          "Versa",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "BRZ",
          "Crosstrek",
          "WRX",
        ],
        Tesla: ["Model 3", "Model S", "Model X", "Model Y"],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
          "C-HR",
          "GR86",
          "Mirai",
          "Prius",
          "Prius Prime",
          "Sienna",
          "YARiS",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Passat",
          "Atlas",
          "Golf Alltrack",
          "Golf R Coupe",
          "Golf R Sedan",
          "Golf Sportwagen",
          "Jetta GLI",
          "Tiguan",
          "e-Golf",
        ],
        Volvo: [
          "C70",
          "S40",
          "S60",
          "S80",
          "S90",
          "V60",
          "V90",
          "XC60",
          "XC90",
        ],
      },
      2017: {
        Acura: ["CL", "Integra", "MDX", "NSX", "RL", "TL", "RDX", "RLX", "TLX"],
        Audi: [
          "A4",
          "A4 Cabriolet",
          "A6",
          "A6 Cabriolet",
          "A6 Competition",
          "A8",
          "A8 W12",
          "S4 Cabriolet",
          "S4 Sedan",
          "S8",
          "TT",
          "A3",
          "A3 Cabriolet",
          "A5",
          "A7",
          "Q3",
          "Q5",
          "Q7",
          "RS3",
          "RS5",
          "RS7",
          "S3",
          "S3 Technik",
          "S5",
          "S6",
          "S7",
          "SQ5",
          "TTS",
          "iTT",
          "iTTS",
        ],
        BMW: [
          "323Ci Convertible/Coupe",
          "325Ci Convertible/Coupe",
          "325i Sedan",
          "325i Wagon",
          "325xi Sedan",
          "325xi Wagon",
          "328i Sedan",
          "330Ci Convertible/Coupe",
          "330Ci Coupe/Convertible",
          "330xi Sedan",
          "540i Wagon",
          "740iL",
          "750iL",
          "Ci Convertible/Coupe",
          "X5",
          "2 Series Convertible/Coupe",
          "300e Hybrid",
          "320i Sedan",
          "328 Wagon",
          "328d Sedan",
          "330e",
          "330i Sedan",
          "330i Wagon",
          "340i Sedan",
          "430i xDrive Coupe",
          "440i Coupe",
          "530e",
          "530i",
          "540i Sedan",
          "640i Gran Coupe",
          "740e xDrive",
          "740i",
          "750Li",
          "750i",
          "94 AH",
          "Alpina B6",
          "Alpina B7",
          "M2",
          "M6",
          "M760i xDrive",
          "X1 28i",
          "X3 28i",
          "X3 30e",
          "X3 35i",
          "X3 xDrive28d",
          "X4",
          "X5",
          "X6",
          "X6 xDrive 35i",
        ],
        Buick: [
          "LeSabre",
          "Regal",
          "Enclave",
          "Encore",
          "Envision",
          "La Crosse",
          "Verano",
        ],
        Chrysler: ["300"],
        Cadillac: [
          "Deville",
          "Eldorado",
          "Escalade",
          "ATS Coupe",
          "ATS Sedan",
          "CT6",
          "CTS Sedan",
          "XT5",
          "XTS",
        ],
        Chevrolet: [
          "Blazer",
          "Camaro",
          "Corvette",
          "Express",
          "Impala",
          "Malibu",
          "Monte Carlo",
          "S-10",
          "Silverado 1500",
          "Silverado 2500 HD",
          "Silverado 3500",
          "Suburban",
          "Tahoe",
          "Bolt",
          "Caprice",
          "City Express",
          "Colorado",
          "Cruze",
          "Equinox",
          "Sonic",
          "Spark",
          "Traverse",
          "Trax",
          "Volt",
        ],
        Dodge: [
          "Dakota",
          "Durango",
          "Ram 1500",
          "Ram 2500",
          "Ram 3500",
          "Challenger",
          "Charger",
          "ProMaster",
          "ProMaster Chassis",
          "ProMaster City",
        ],
        Ford: [
          "Crown Victoria",
          "E Series",
          "Escape",
          "Expedition",
          "Explorer",
          "F-150",
          "F-250",
          "F-350",
          "Focus",
          "Mustang",
          "Ranger",
          "SVT Cobra",
          "Taurus",
          "C-Max",
          "Edge",
          "Fiesta",
          "Flex",
          "Fusion",
          "Shelby GT350",
          "Transit",
        ],
        GMC: [
          "Envoy",
          "Sierra 1500",
          "Sierra 2500HD",
          "Acadia",
          "Canyon",
          "Sierra 3500HD",
          "Terrain",
        ],
        Honda: [
          "Accord",
          "Insight",
          "S2000",
          "Civic (All Except SI)",
          "Civic SI",
          "Fit",
          "HR-V",
          "Pilot",
          "Ridgeline",
        ],
        Hyundai: [
          "Accent",
          "Elantra",
          "Santa Fe",
          "Sonata",
          "Tiburon",
          "XG300",
          "Azera",
          "Ioniq",
          "Tucson",
          "Veloster",
        ],
        Jaguar: ["XJ", "XK", "F-PACE", "F-type", "XE", "XF"],
        Jeep: [
          "Grand Cherokee",
          "Cherokee",
          "Compass",
          "Patriot",
          "Renegade",
          "Wrangler 2-Door",
          "Wrangler 4-Door",
        ],
        Kia: [
          "Optima",
          "Spectra",
          "Sportage",
          "Cadenza",
          "Forte",
          "Forte5",
          "Niro",
          "Rio",
          "Sorento",
          "Soul",
        ],
        "Land Rover": [
          "Range Rover",
          "Range Rover (All Other Trims)",
          "Range Rover Evoque",
          "Range Rover Evoque SVR",
          "Range Rover Sport",
          "Range Rover Sport SE",
          "Range Rover Sport SV",
          "Range Rover Sport SVR",
        ],
        Lexus: [
          "ES",
          "GS",
          "IS",
          "IS Convertible",
          "LS",
          "LX",
          "RX",
          "SC",
          "NX",
          "RC, F",
        ],
        Lincoln: ["Navigator", "MKC", "MKT", "MKX", "MKZ"],
        Mazda: ["Miata", "Tribute", "CX-3", "CX-5", "CX-9", "MAZDA3", "MAZDA6"],
        Mercedes: [
          "C-Class C240",
          "CL-Class",
          "E-Class (All Except Convertible)",
          "M Class",
          "S-Class",
          "SL Class",
          "C-Class AMG",
          "C-Class C300",
          "CLA Class",
          "CLS Class",
          "CLS Class AMG",
          "G Class",
          "GLA Class",
          "GLC Class",
          "GLE Class",
          "GLS Class",
          "S-Class 450",
          "S-Class 550",
          "S-Class 560",
          "SLC Class",
          "Sprinter",
        ],
        Mitsubishi: [
          "Eclipse",
          "Galant",
          "Lancer",
          "Mirage",
          "Mirage G4",
          "Outlander",
          "Outlander Hybrid",
          "Outlander Sport",
        ],
        Nissan: [
          "Altima Sedan",
          "Frontier",
          "Maxima",
          "Pathfinder",
          "Quest",
          "Sentra",
          "Xterra",
          "370Z",
          "Armada",
          "GT-R",
          "Juke",
          "Leaf",
          "Murano",
          "Rogue",
          "Titan",
          "Versa",
        ],
        Pontiac: ["Firebird", "Grand Am", "Grand Prix"],
        Ram: [
          "1500",
          "2500",
          "3500",
          "Dakota",
          "3500 Chassis",
          "4500 Chassis",
          "5500 Chassis",
        ],
        Saab: ["9 3", "9 5"],
        Subaru: [
          "Forester",
          "Impreza",
          "Impreza RS",
          "Legacy",
          "Outback",
          "Crosstrek",
          "WRX",
        ],
        Toyota: [
          "4Runner",
          "Avalon",
          "Camry",
          "Celica",
          "Corolla",
          "Echo",
          "Highlander",
          "RAV4",
          "Sequoia",
          "Solara Convertible",
          "Solara Coupe",
          "Tacoma",
          "Tacoma with front bench",
          "Tundra",
          "GR86",
          "Mirai",
          "Prius",
          "Prius Prime",
          "YARiS",
        ],
        Volkswagen: [
          "Beetle",
          "Golf",
          "Golf GTI",
          "Jetta",
          "Passat",
          "CC",
          "Golf Alltrack",
          "Golf R Coupe",
          "Golf R Sedan",
          "Golf Sportwagen",
          "Tiguan",
          "Touareg",
          "e-Golf",
        ],
        Volvo: [
          "C70",
          "S40",
          "S60",
          "S80",
          "S90",
          "V60",
          "V90",
          "XC60",
          "XC90",
        ],
        Tesla: ["Model 3", "Model S", "Model X"],
      },
    };
  function s() {
    !(function () {
      const o = a.value && e.value && r.value;
      (submitButton.disabled = !o), (i.style.display = o ? "flex" : "none");
    })();
  }
  a.addEventListener("change", function () {
    !(function () {
      const i = a.value,
        n = o[i] || [];
      (e.innerHTML = '<option value="">Select Make</option>'),
        (r.innerHTML = '<option value="">Select Model</option>'),
        i
          ? ((e.disabled = !1),
            n.forEach((a) => {
              const r = document.createElement("option");
              (r.value = a.toLowerCase()),
                (r.textContent = a),
                e.appendChild(r);
            }))
          : (e.disabled = !0),
        s();
    })();
  }),
    e.addEventListener("change", function () {
      !(function () {
        const i = a.value,
          o = e.options[e.selectedIndex]?.text,
          l = n[i]?.[o] || [];
        (r.innerHTML = '<option value="">Select Model</option>'),
          o
            ? ((r.disabled = !1),
              l.forEach((a) => {
                const e = document.createElement("option");
                (e.value = a.toLowerCase()),
                  (e.textContent = a),
                  r.appendChild(e);
              }))
            : (r.disabled = !0),
          s();
      })();
    }),
    submitButton?.addEventListener("click", function (a) {}),
    s(),
    setInterval(s, 1e3);
});
